import { render } from "./ProjectUserProfileViewModal.vue?vue&type=template&id=3e43b841&ts=true"
import script from "./ProjectUserProfileViewModal.vue?vue&type=script&lang=ts"
export * from "./ProjectUserProfileViewModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__